/** Экран непредвиденной ошибки маршрута — вместо служебного вывода React Router. */
import { isRouteErrorResponse, Link, useRouteError } from 'react-router-dom'

import { Button } from '@/shared/ui/Button'

function describe(error: unknown): string {
  if (isRouteErrorResponse(error)) return `${error.status} ${error.statusText}`
  if (error instanceof Error) return error.message
  return 'Неизвестная ошибка'
}

export function ErrorPage() {
  const error = useRouteError()

  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-5 bg-bg px-4">
      <div className="w-full max-w-prose">
        <h1 className="text-2xl font-bold">Страница не загрузилась</h1>
        <p className="mt-2 text-meta text-ink-soft">
          Обновите страницу. Если ошибка повторится, сообщите нам текст ниже.
        </p>
        <pre className="mt-4 overflow-x-auto rounded-md border border-line bg-surface p-3 font-mono text-label text-ink-soft">
          {describe(error)}
        </pre>
        <div className="mt-5 flex flex-wrap gap-3">
          <Button onClick={() => location.reload()}>Обновить страницу</Button>
          <Link to="/">
            <Button variant="secondary">На главную</Button>
          </Link>
        </div>
      </div>
    </div>
  )
}
